import { ButtonSurface, PrimaryButton } from "@/components/buttons"

export function ButtonLink({
  href,
  children,
  surface,
}: {
  href: string
  children: React.ReactNode
  surface: ButtonSurface
}) {
  return (
    <PrimaryButton
      href={href}
      surface={surface}
    >
      {children}
    </PrimaryButton>
  )
}
